<template>
  <LoadingWrapper :state="status" v-if="canSeeData">
    <PulseSlide :feedback-topic="data.feedbackTopic" :questions="data.questions" />
  </LoadingWrapper>

  <div v-else class="flex h-full flex-col items-center justify-center">
    <BaseEmptyVisual class="max-w-sm" />
    <p class="text-body-large lg:text-title-large">Es sind noch keine Feedbackdaten freigegeben.</p>
  </div>
</template>
<script lang="ts" setup>
  import LoadingWrapper from '../../../core/components/loading/LoadingWrapper.vue'
  import { useFinalPulseSlide } from '../composable/use-final-pulse-slide'
  import PulseSlide from './PulseSlide.vue'
  import { useRoute } from 'vue-router'
  import { computed } from 'vue'
  import BaseEmptyVisual from '@/core/components/base/empty-visual/BaseEmptyVisual.vue'

  const route = useRoute()
  const feedbackTopicId = computed(() => route.params.feedbackTopicId as string)

  const { status, data, canSeeData } = useFinalPulseSlide(feedbackTopicId)
</script>
